module.exports = __webpack_public_path__ + "img/bg_index_edu_02.02ae1eff.png";